import { BaseModel } from "model/BaseModel";
import Pessoa from "model/administracao/cadastro/Pessoa";
import ItemPedido from "./ItemPedido";

import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";
import CondicaoPagamento from "model/fiscal/CondicaoPagamento";
import FormaPagamento from "model/fiscal/FormaPagamento";
import Representante from "model/fiscal/Representante";

export default class Pedido implements BaseModel {
    unidadeOrganizacional?: UnidadeOrganizacional | null;
    condicaoPagamento?: CondicaoPagamento | null;
    formaPagamento?: FormaPagamento | null;
    representante?: Representante | null;
    id: number;
    codigo: string | null = "";
	dataHoraGeracao: Date | null;
	dataPrevista: Date | null;
    numeroPedido: number;
	cliente: Pessoa;
	status: string;
	itens: ItemPedido[];

    constructor(
        id: number = 0, 
        dataHoraGeracao: Date|null = null, 
        dataPrevista: Date|null = null, 
        numeroPedido: number = 0, 
        cliente: Pessoa = new Pessoa(), 
        status: string = "ABERTO", 
        itens: ItemPedido[] = []
    ) {
        this.id = id;
        this.dataHoraGeracao = dataHoraGeracao;
        this.dataPrevista = dataPrevista;
        this.numeroPedido = numeroPedido;
        this.cliente = cliente;
        this.status = status;
        this.itens = itens;
    }
}